import api from './api';

export const getReferralStats = async () => {
  try {
    const response = await api.get('/api/referrals/stats');
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

export const getAllReferrals = async (filters) => {
  try {
    const response = await api.get('/api/referrals', { params: filters });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
